import React, { useState } from 'react';
import LotterySearchModal from './LotterySearchModal';
import { resolveLotteryByCode } from '../utils/lotteryLookup';

/**
 * Champ "code loterie" réutilisable (rapports, filtres...) :
 *   - input numérique (`inputMode="numeric"`) ;
 *   - `onFocus` sélectionne le contenu (retape facile, mobile inclus) ;
 *   - `onBlur` résout le code tapé en nom de loterie (via utils/lotteryLookup)
 *     et l'affiche à côté ; "Loterie introuvable" en rouge sinon ;
 *   - bouton 🔍 -> `LotterySearchModal`.
 * La page garde la source de vérité : elle passe `value`/`name` et reçoit
 * `onChange(code)` (frappe) + `onResolve(code, name)` (blur / modal).
 */
export default function LotteryCodeField({
  value,
  name = '',
  onChange,
  onResolve,
  allowAll = true,
  inputClass = '',
  iconClass = '',
  nameClass = '',
  errClass = '',
  placeholder,
}) {
  const [err, setErr] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  const resolve = async () => {
    const c = String(value ?? '').trim();
    if (c === '' || (!allowAll && c === '0')) { setErr(''); return; }
    const r = await resolveLotteryByCode(c);
    if (r) { onResolve(r.code, r.name); setErr(''); } else { setErr('Loterie introuvable'); }
  };

  return (
    <>
      <input
        className={inputClass}
        type="text"
        inputMode="numeric"
        value={value}
        placeholder={placeholder}
        onChange={(e) => { onChange(e.target.value); setErr(''); }}
        onFocus={(e) => e.target.select()}
        onBlur={resolve}
      />
      <span className={iconClass} onClick={() => setModalOpen(true)}>🔍</span>
      {err
        ? <span className={errClass || nameClass} style={{ color: '#c0392b' }}>{err}</span>
        : (name ? <span className={nameClass}>{name}</span> : null)}
      {modalOpen && (
        <LotterySearchModal
          allowAll={allowAll}
          onSelect={(code, nm) => { onResolve(String(code), nm || ''); setErr(''); }}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
